export default {
  CLIENT_API: 'dd/MM/yyyy'
};
